import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function RoomLayout() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className="p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Event and Banquet Management</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/banquet-management/event-planning')}
              className="btn"
            >
              Event Planning
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/banquet-management/room-layout-capacity')
              }
              className="btn text-black font-bold"
            >
              Room Layout & Capacity Planning
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/banquet-management/event-billing')}
              className="btn"
            >
              Billing for Events
            </button>
          </div>
        </header>
        <ComingSoon />
      </div>
    </div>
  );
}

export default RoomLayout;
